import styled from 'styled-components';

import BasicDonutChart from 'components/common/chart/BasicDonutChart';
import { useGetGroupInsights } from 'hooks/queries/dashboard';
import useGetSearchParams from 'hooks/useGetSearchParams';
import CoreLoading from 'shared/CoreLoading';
import { ReportSectionCard, ReportTopHeader } from 'styles/styled-components/report';
import style from 'styles/styled-components/style';

const mockData = {
	overallCommentRate: {
		adRelatedComment: 0,
		normalComment: 0,
		socialBizKeywordComment: 0,
	},
};

function CommentsStats() {
	const [groupId] = useGetSearchParams(['groupId']);

	const { data: groupInsights, isLoading: groupInsightsLoading } =
		useGetGroupInsights(groupId);

	// 가장 큰 수 가진 key와 value를 추출
	const commentRates = groupInsights?.overallCommentRate ?? mockData.overallCommentRate;
	const [largestKey, largestValue] = Object.entries(commentRates).reduce(
		(max, current) => (current[1] > max[1] ? current : max),
		['', 0],
	);

	// 한글 매핑 (필요 시 추가)
	const commentRateLabels: { [key: string]: string } = {
		adRelatedComment: '광고 관련 댓글',
		normalComment: '일반 댓글',
		socialBizKeywordComment: '소셜비즈 키워드',
	};

	if (groupInsightsLoading) {
		return (
			<ReportSectionCard>
				<ReportTopHeader>전체 댓글 비율</ReportTopHeader>
				<Grid flex="center" direction="column" _height="100%">
					<CoreLoading color_type="gray" />
				</Grid>
			</ReportSectionCard>
		);
	}
	return (
		<ReportSectionCard>
			<ReportTopHeader>전체 댓글 비율</ReportTopHeader>
			<Grid flex="between" direction="column" align_items="start" _gap="24px">
				<Grid flex="start" align_items="end">
					<Text typo="h3">{commentRateLabels[largestKey]}</Text>
					<Text typo="span_bold">({Math.round(largestValue)}%)</Text>
				</Grid>
				<Grid _width="100%">
					<RelativeGrid>
						<AbsoluteChart>
							<BasicDonutChart
								value={[
									Math.round(commentRates.adRelatedComment),
									Math.round(commentRates.normalComment),
								]}
								max_label={true}
								unit="%"
								value_name={[
									commentRateLabels['adRelatedComment'],
									commentRateLabels['normalComment'],
								]}
							/>
							<Grid flex="center">
								<Text typo="p">{'*소셜비즈 키워드 제외'}</Text>
							</Grid>
						</AbsoluteChart>
					</RelativeGrid>
				</Grid>
			</Grid>
		</ReportSectionCard>
	);
}

const { Grid, Text } = style;

const RelativeGrid = styled(Grid)`
	position: relative;
`;

const AbsoluteChart = styled.div`
	position: absolute;
	top: 30px;
`;

export default CommentsStats;
